export default {"src":"/_next/static/media/KR.f28f4706.svg","height":18,"width":18};